import { Button } from "react-bootstrap";
import "../listingTitle/listingtitle.scss";
import { useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import { useCallback, useMemo, useState } from "react";

const ItemListingTitle = ({
  title,
  buttonTitle,
  href,
  disRecords,
  totalRecords,
  searchVal,
  setSearchVal,
  defaultFilter,
  isAddPermitted,
}: any) => {
  const navigate = useNavigate();
  const [localSearchText, setLocalSearchText] = useState(searchVal?.searchText ?? "");

  // Create a debounced version of the search handler
  const debouncedSearch = useMemo(
    () => debounce((value: string) => {
      setSearchVal({ ...searchVal, searchText: value });
    }, 500),
    [searchVal, setSearchVal]
  );

  // Handle search input change
  const handleSearchChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLocalSearchText(value);
    debouncedSearch(value);
  }, [debouncedSearch]);

  // Handle active checkbox change
  const handleActiveChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchVal({
      ...searchVal,
      active: e.target.checked ? true : null,
    });
  }, [searchVal, setSearchVal]);

  // Handle clear all
  const handleClearAll = useCallback(() => {
    setLocalSearchText("");
    setSearchVal({ ...defaultFilter });
  }, [defaultFilter, setSearchVal]);

  return (
    <div className="listing-title-box">
      <div className="listing-title-info">
        <h2>{title}</h2>
        <p>
          Displaying {disRecords} of {totalRecords} Results
        </p>
      </div>
      <div className="listing-searchbar-wrapper">
        <div className="listing-searchbar-item-wrapper">
          <div className="listing-searchbar-item-box">
            <input
              type="text"
              min={0}
              className="form-control"
              placeholder="Search"
              onChange={handleSearchChange}
              value={localSearchText}
              autoFocus
              onFocus={(e) => e.target.select()}
            />
          </div>
          <div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="checkbox"
                checked={searchVal?.active ?? false}
                onChange={handleActiveChange}
              />
              <label className="form-check-label">Active</label>
            </div>
          </div>
          <Button
            type="button"
            variant="outline-secondary"
            className="btn-search"
            onClick={handleClearAll}
          >
            Clear All
          </Button>
        </div>
      </div>
      <div className="listing-action-box">
        {isAddPermitted && (
          <>
            <div className="action-box">
              <Button variant="primary" onClick={() => navigate(href)}>
                <i className="bi bi-plus"></i>
                {buttonTitle}
              </Button>
            </div>
            {/* <div className="filter-box">
              <ReactSVG className="svg-box" wrapper="span" src={filtericon} />
            </div> */}
          </>
        )}
      </div>
    </div>
  );
};

export default ItemListingTitle;
